import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  Button,
  Typography,
  Box,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const WHATSAPP_POLICY_URL =
  "https://www.whatsapp.com/legal/business-policy?lang=es";

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 16,
    padding: theme.spacing(1, 1, 2),
    maxWidth: 520,
  },
  title: {
    color: theme.palette.primary.main,
    fontWeight: 800,
    fontSize: 22,
    textAlign: "center",
    marginBottom: theme.spacing(2),
  },
  list: {
    margin: 0,
    paddingLeft: 20,
    color: theme.palette.text.primary,
    fontSize: 14,
    lineHeight: 1.55,
    "& li": {
      marginBottom: 10,
    },
  },
  link: {
    color: theme.palette.primary.main,
    fontWeight: 700,
  },
  actions: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(3),
  },
  confirm: {
    borderRadius: 999,
    textTransform: "none",
    fontWeight: 800,
    padding: "8px 28px",
  },
  closeBtn: {
    position: "absolute",
    top: 8,
    right: 8,
  },
}));

const WhatsAppPolicyWarning = ({ storageKey, variant = "contacts" }) => {
  const classes = useStyles();
  const key = `wt_wa_policy_${storageKey || "default"}`;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (sessionStorage.getItem(key) === "1") return;
    } catch (err) {
      // ignore storage errors
    }
    setOpen(true);
  }, [key]);

  const handleClose = () => {
    try {
      sessionStorage.setItem(key, "1");
    } catch (err) {
      // ignore
    }
    setOpen(false);
  };

  const isGroups = variant === "groups";

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ className: classes.paper, style: { position: "relative" } }}
    >
      <IconButton className={classes.closeBtn} onClick={handleClose} size="small">
        <CloseIcon fontSize="small" />
      </IconButton>
      <DialogContent>
        <Typography className={classes.title}>¡Aviso Importante!</Typography>
        <Box component="ul" className={classes.list}>
          {isGroups ? (
            <>
              <li>
                Los envíos masivos a <strong>grupos de WhatsApp</strong> pueden
                provocar restricciones o el bloqueo de la cuenta si se perciben
                como <strong>SPAM</strong> o actividad no solicitada.
              </li>
              <li>
                Usa grupos donde tu negocio ya participa y evita saturar a los
                participantes con mensajes repetidos.
              </li>
              <li>
                Debes asegurarte de seguir las políticas de{" "}
                <a
                  className={classes.link}
                  href={WHATSAPP_POLICY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  WhatsApp
                </a>
                .
              </li>
            </>
          ) : (
            <>
              <li>
                Los envíos masivos a contactos con los que nunca has interactuado
                pueden ser causa de bloqueo al ser considerados <strong>SPAM</strong>.
              </li>
              <li>
                Debes asegurarte de seguir las políticas de{" "}
                <a
                  className={classes.link}
                  href={WHATSAPP_POLICY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  WhatsApp
                </a>
                .
              </li>
            </>
          )}
        </Box>
        <Box className={classes.actions}>
          <Button
            variant="contained"
            color="primary"
            className={classes.confirm}
            onClick={handleClose}
          >
            ¡Entendido!
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default WhatsAppPolicyWarning;
export { WHATSAPP_POLICY_URL };
